import axios from '../apis/apicidtech';

export const setEvento = (evento = {}) => {
    localStorage.setItem('eventosessioncred', JSON.stringify(evento));    
}

export const getEvento = () => {
    return JSON.parse(localStorage.getItem('eventosessioncred'));
}

export const removeEvento = () => {
    localStorage.removeItem('eventosessioncred');
}

export const getDecodeEvento = async (props, campo_imagem) => {
    
    if(!Object.keys(props.match.params).length){
        return false;
    }
    
    const filtro = {
        promotora: props.match.params.promotora,
        ideventocriptografado: props.match.params.evento
    }
    
    const result = await axios.get('promotoras/eventos/dados/web',
        {
            headers: {
                Accept: 'application/json'
            },
            params: {
                ...filtro
            }
      }
    );
    
    let dados_gerais = {};
    if(result.data&&result.data[0].idevento){
        
        const imagem = result.data[0].imagens.filter(campos => {
            return campos.campo===campo_imagem;
        });
        
        dados_gerais = {
            ...result.data[0],
            ...filtro,
            [campo_imagem]: imagem[0]&&imagem[0].imagem?imagem[0].imagem:null
        }        
    }
    
    return dados_gerais;
}

export const setLinguagemCred = (categoria) => {
    localStorage.setItem('linguagem', categoria);
}

export const getLinguagemCred = () => {
    return localStorage.getItem('linguagem');
}

export const setEmailConfirmacaoCred = (status = 0) => {
    localStorage.setItem('confemailcred', status);
}

export const getEmailConfirmacaoCred = () => {
    return localStorage.getItem('confemailcred');
}

export const setCategoriaCred = (categoria) => {
    localStorage.setItem('categoriacred', categoria);
}

export const getCategoriaCred = () => {
    return localStorage.getItem('categoriacred');
}

export const setCategoriaCredDescricao = (descricao) => {
    localStorage.setItem('categoriacreddescricao', descricao);
}

export const getCategoriaCredDescricao = () => {    
    const desc = localStorage.getItem('categoriacreddescricao');    
    if(desc !== null && desc !== undefined && desc !== 'undefined' && desc.length){
        return JSON.parse(desc);
    }else{
        return {};
    }    
}

export const setCategoriaUsuario = (categoria) => {
    localStorage.setItem('categoriauser', categoria);
}

export const getCategoriaUsuario = () => {
    return localStorage.getItem('categoriauser');
}


export const getUserProduct = () => {
    const user = localStorage.getItem('userProduct');
    if(user !== null && user !== undefined && user !== 'undefined'){
        return JSON.parse(user);
    }else{
        return {};
    } 
}

export const setUserProduct = (user) => {
    localStorage.setItem('userProduct', JSON.stringify(user));
}

export const removeUserProduct = () => {
    localStorage.removeItem('userProduct');
}




export const getUserLoginCred = () => {
    const user = localStorage.getItem('loginusercred');
    if(user !== null && user !== undefined && user !== 'undefined'){
        return JSON.parse(user);
    }else{
        return {};
    } 
}

export const setUserLoginCred = (user) => {
    localStorage.setItem('loginusercred', JSON.stringify(user));
}

export const removeUserLoginCred = () => {
    localStorage.removeItem('loginusercred');
}

export const setCredencialPronta = (cred) => {
    localStorage.setItem('credencialpronta', JSON.stringify(cred));
}

export const getCredencialPronta = () => {
    const cred = localStorage.getItem('credencialpronta');    
    if(cred !== null && cred !== undefined && cred !== 'undefined'){
        return JSON.parse(cred);
    }else{
        return {};
    }
}

export const getPedidoConfirmado = () => {
    const pedido = localStorage.getItem('pedidoconfirmado');
    if(pedido !== null && pedido !== undefined && pedido !== 'undefined'){        
        return JSON.parse(pedido);
    }else{
        return {};
    } 
}

export const setPedidoConfirmado = (pedido) => {
    localStorage.setItem('pedidoconfirmado', JSON.stringify(pedido));
}

export const removePedidoConfirmado = () => {
    localStorage.removeItem('pedidoconfirmado');
}

export const setLogoutusercred = () => {
    setUserLoginCred({});
    setEmailConfirmacaoCred(0);
    removeUserProduct();
    removePedidoConfirmado();
}

export const setListenerProdutoRemovido = (prods = []) => {
    localStorage.setItem('listenerProdutoRemovido', JSON.stringify(prods));
}

export const getListenerProdutoRemovido = () => {
    const prods = localStorage.getItem('listenerProdutoRemovido');
    if(prods !== null && prods !== undefined && prods !== 'undefined'){
        return JSON.parse(prods);
    }else{
        return [];
    } 
}

export const setAcessoLinkCategoriaDireto = (categoria) => {
    localStorage.setItem('acessolinkdireto', categoria);
}

export const getAcessoLinkCategoriaDireto = () => {
    const categoria = localStorage.getItem('acessolinkdireto');
    if(categoria !== null && categoria !== undefined && categoria !== 'undefined'){
        return categoria;
    }else{
        return false;
    }
}